<template>
  <div class="swiper" id="imageSwiper">
    <div class="swiper-wrapper">
      <div
        v-for="(image, key) in imageList"
        :key="key"
        class="swiper-slide"
      >
        <img @load="handleLoad(image)" :src="image.url" v-show="!image.loading" />
        <loader width="89.066666vw" height="38.4vw" v-if="image.loading"></loader>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Loader from '@/components/loader/Index.vue'

import newsSwiperMixins from '@/mixins/home/newsSwiperMixins.js'

export default {
  mixins: [newsSwiperMixins],
  components: {
    Loader,
  },
}
</script>

<style lang="scss" scoped>
.swiper {
  margin: 0;
  width: 89.066666vw;
  height: 45.066666vw;

  .swiper-slide {
    ::v-deep img {
      width: 89.066666vw;
      height: 38.4vw;
    }
  }

  .swiper-pagination {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;

    ::v-deep .swiper-pagination__btn {
      display: block;
      margin: 0 1.333333vw;
      width: 3.333333vw;
      height: 3.333333vw;
      background: url('~@/assets/img/common/news_swiper.png') no-repeat;
      background-size: 100%;
      background-position: 0 0;
    }

    ::v-deep .swiper-pagination--active {
      background-position: 0 -3.333333vw;
    }
  }
}
</style>